enum MarkType {
    BOLD = 'bold',
    ITALIC = 'italic',
    UNDERLINE = 'underline',
    CLASSNAME_OR_ID = 'classnameOrId',

    STRIKE_THROUGH = 'strikethrough',
    INLINE_CODE = 'inlineCode',


    SUBSCRIPT = 'subscript',
    SUPERSCRIPT = 'superscript',
    BREAK = 'break'
}

export default MarkType